import React, { ComponentPropsWithoutRef, ElementType } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { activeItemChanged } from '../../../pages/item-details/store';
import { selectSearchParams } from '../../store/search';
import { getItemMetricParams } from '../../utils/helpers/item';
import { compilePath } from '../../utils/helpers/routes';

export interface SearchResultButtonProps
  extends ComponentPropsWithoutRef<ElementType> {
  component?: ElementType;
  item;
  index;
}

const SearchResultButton = ({
  component: Component = 'button',
  item,
  index,
  ...props
}: SearchResultButtonProps) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const searchParams = useSelector(selectSearchParams);
  const metricParams = getItemMetricParams(item, searchParams);

  const handleClick = () => {
    analytics.track('Search Suggest Item Select', metricParams);
    dispatch(activeItemChanged({ item, index, datasource: 'search_v1' }));
    history.push({
      pathname: compilePath('details'),
      search: history.location.search,
    });
  };

  return <Component {...props} onClick={handleClick} />;
};

export default SearchResultButton;
